import axios from 'axios';
import _ from 'lodash';

export default class ApiBaseService {
  constructor() {
    this.httpClient = axios;
    this.userToken = '';
  }

  setUserToken(token) {
    this.userToken = token;
  }

  resetUserToken() {
    this.setUserToken();
  }

  httpGet(url, options) {
    const optionsWithUserToken = { ...options };
    _.set(optionsWithUserToken, 'headers.Authorization', this.userToken);
    _.set(optionsWithUserToken, 'headers.user-token', this.userToken);
    return this.httpClient.get(url, optionsWithUserToken);
  }

  httpPut(url, data, options) {
    const optionsWithUserToken = { ...options };
    _.set(optionsWithUserToken, 'headers.Authorization', this.userToken);
    _.set(optionsWithUserToken, 'headers.user-token', this.userToken);
    return this.httpClient.put(url, data, optionsWithUserToken);
  }

  httpPost(url, data, options) {
    const optionsWithUserToken = { ...options };
    _.set(optionsWithUserToken, 'headers.Authorization', this.userToken);
    _.set(optionsWithUserToken, 'headers.user-token', this.userToken);
    return this.httpClient.post(url, data, optionsWithUserToken);
  }

  httpPatch() {
    throw new Error('not implemented', this);
  }

  httpDelete() {
    throw new Error('not implemented', this);
  }
}
